import { Component } from '@angular/core';
import { EventType, Router } from '@angular/router';

@Component({
    selector: 'app-action-buttons',
    templateUrl: './action-buttons.component.html',
    styleUrls: ['./action-buttons.component.scss'],
    standalone: false,
})
export class ActionButtonsComponent {
    public visible: boolean = true;
    public showPhoneNumber: boolean = false;

    public constructor(private router: Router) {
        this.subscribeForRouterEvents();
    }

    private subscribeForRouterEvents(): void {
        this.router.events.pipe().subscribe((event) => {
            if (event.type === EventType.NavigationEnd) {
                this.visible = event.urlAfterRedirects.indexOf('portal') === -1;
            }
        });
    }

    public togglePhone(): void {
        this.showPhoneNumber = !this.showPhoneNumber;
    }

    public closePhone(): void {
        if (this.showPhoneNumber) {
            this.showPhoneNumber = false;
        }
    }
}
